import { getLocation } from 'services/axios/location'

export const actions = {
  GET_LOCATIONS_DATA: 'GET_LOCATIONS_DATA',
}

//  Action creators
export const getLocationsData = ({ skip, limit }) => {
  return async (dispatch) => {
    const response = await getLocation(skip, limit)
    if (response?.status === 200 && response?.data?.message === 'success') {
      dispatch({
        type: actions.GET_LOCATIONS_DATA,
        payload: {
          locationList: response?.data?.data?.locationList,
          totalCount: response?.data?.data?.totalCount,
        },
      })
    }
  }
}

export const handlePagination = (pagination) => {
  return {
    type: 'HANDLE_PAGINATION',
    payload: pagination,
  }
}
